const DownloadTabs = function() {
    function DownloadTabs() {
        this.selector = {
            downloads: document.querySelectorAll('.tabs-contents .tab-popup-content a.download-link')
        }
        this.load();
    }
    
    DownloadTabs.prototype.load = function() {
        var _ = this;
        if(_.selector.downloads.length > 0) {
            _.selector.downloads.forEach(dl => {
                dl.addEventListener("click", event => {
                    event.preventDefault();
                    _.download(event.target.closest("a").href, event.target.closest("a").dataset.filename);
                    alert(event.target.closest("a").dataset.filename + ' is downloading in Background!');
                })
            })
        }
    }
    DownloadTabs.prototype.download = async function(url, filename) {
        var _ = this;
        const data = await fetch(url);
        const blob = await data.blob();
        const objectUrl = URL.createObjectURL(blob);    
        const link = document.createElement('a');
        link.setAttribute('href', objectUrl);
        link.setAttribute('download', filename);
        link.style.display = 'none';    
        document.body.appendChild(link);
        link.click();      
        document.body.removeChild(link);
    }
    DownloadTabs = new DownloadTabs;
}

DownloadTabs();